<template>
  <a-date-picker
    @change="(e)=>findEvent({e})"
    v-bind="$attrs.item"
    v-model="modelList[name]"
  />
</template>

<script>
import formMixin from "@/minxin/form.mixin.js";
import { DatePicker } from "ant-design-vue";
export default {
  mixins: [formMixin],
  components: { [DatePicker.name]: DatePicker },
  props: {
    name: {},
    modelList: {},
    funcList: {},
  },
};
</script>
